import Statistics from '../components/templates/statistics';

export const StatisticsContainer = () => {
  return <Statistics />;
};
